import { useMutation } from 'platform/useMutation';
import { gql } from '@apollo/client';
import { useObservability } from 'shared/helpers/observability';
import { useQualificationContext } from 'shared/helpers/QualificationContext';

// eslint-disable-next-line no-restricted-syntax
import {
  UpdateHomeConditionResponse,
  UpdateHomeConditionResponseVariables,
} from './__generated__/UpdateHomeConditionResponse';

export const UPDATE_HOME_CONDITIONS_RESPONSE = gql`
  mutation UpdateHomeConditionResponse(
    $leadId: String!
    $selectedProxyImageIds: [String!]
    $flowDifficulty: String
    $skipped: Boolean!
    $hasMlsPhotos: Boolean!
  ) {
    sellDirect {
      updateHomeConditionResponse(
        input: {
          leadId: $leadId
          selectedProxyImageIds: $selectedProxyImageIds
          flowDifficulty: $flowDifficulty
          skipped: $skipped
          hasMlsPhotos: $hasMlsPhotos
        }
      ) {
        homeConditionResponse {
          flowDifficulty
          submittedAt
          skippedAt
          homeConditions {
            title
            selectedProxyImageId
          }
        }
      }
    }
  }
`;

/** Updates the HomeConditionResponse for the home condition flow with the user responses for the selected proxy ids or the skipped value  */
export const useUpdateHomeConditionResponse = () => {
  const { sellerLeadUUID } = useQualificationContext();
  const { trackError } = useObservability();
  const [update, { loading, data, error }] = useMutation<
    UpdateHomeConditionResponse,
    UpdateHomeConditionResponseVariables
  >(UPDATE_HOME_CONDITIONS_RESPONSE, {
    fetchPolicy: 'no-cache',
    awaitRefetchQueries: true,
  });
  /** Expects an array of selectedProxyImage Ids, the response to the flowDifficulty, and a boolean value of whether they skipped the flow or not */
  const updateHomeConditionResponse = (
    selectedProxyImageIds: Array<string>,
    hasMlsPhotos: boolean,
  ) => {
    if (!sellerLeadUUID) {
      trackError('update-home-condition-response-without-lead-id', error);
      return;
    }
    return update({
      variables: {
        leadId: sellerLeadUUID,
        selectedProxyImageIds: selectedProxyImageIds,
        flowDifficulty: undefined,
        skipped: false,
        hasMlsPhotos: hasMlsPhotos,
      },
    }).catch((error) => trackError('update-home-condition-response', error));
  };

  return { updateHomeConditionResponse, data, loading, error };
};
